import { render, staticRenderFns } from "./CharacterBar.vue?vue&type=template&id=656da6d9&scoped=true&"
import script from "./CharacterBar.vue?vue&type=script&lang=ts&"
export * from "./CharacterBar.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterBar.vue?vue&type=style&index=0&id=656da6d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656da6d9",
  null
  
)

export default component.exports